var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopBarVenueGenericOver(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "top_bar-venue-generic-over") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "top_bar-venue-generic-over"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,12 C24,18.6273872 18.6274113,24 12.0000539,24 C5.37258867,24 0,18.6273872 0,12 C0,5.37261281 5.37258867,0 12.0000539,0 C18.6274113,0 24,5.37261281 24,12",
    id: "Fill-1-Copy-2",
    fill: "#4E565A"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Clip-2",
    points: "3.63636364 5.09105145 20.1785687 5.09105145 20.1785687 18.9947961 3.63636364 18.9947961"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8465485,18.2829973 L17.0923513,18.2829973 L17.0923513,12.4309431 C17.0923513,12.2341308 17.2514383,12.0750437 17.4482507,12.0750437 L18.8814576,12.0750437 L11.9076085,5.92189865 L4.93340348,12.0750437 L6.36661044,12.0750437 C6.56342282,12.0750437 6.72250986,12.2341308 6.72250986,12.4309431 L6.72250986,18.2829973 L9.96866847,18.2829973 L9.96866847,13.9830205 C9.96866847,13.7862081 10.1277555,13.6271211 10.3245679,13.6271211 L13.4906491,13.6271211 C13.6874615,13.6271211 13.8465485,13.7862081 13.8465485,13.9830205 L13.8465485,18.2829973 Z M17.4482507,18.9947961 L13.4906491,18.9947961 C13.2938368,18.9947961 13.1347497,18.8357091 13.1347497,18.6388967 L13.1347497,14.3389199 L10.6804673,14.3389199 L10.6804673,18.6388967 C10.6804673,18.8357091 10.5210244,18.9947961 10.3245679,18.9947961 L6.36661044,18.9947961 C6.17015397,18.9947961 6.01071103,18.8357091 6.01071103,18.6388967 L6.01071103,12.7868426 L3.99240542,12.7868426 C3.84399536,12.7868426 3.71160077,12.6950205 3.65928356,12.5565756 C3.60696634,12.4181308 3.64575938,12.2618909 3.7568,12.1640186 L11.672359,5.18020426 C11.8065331,5.06133385 12.0086839,5.06133385 12.142858,5.18020426 L20.0580611,12.1640186 C20.1694576,12.2618909 20.2078948,12.4181308 20.1559335,12.5565756 C20.1032603,12.6950205 19.9708658,12.7868426 19.8228116,12.7868426 L17.8041501,12.7868426 L17.8041501,18.6388967 C17.8041501,18.8357091 17.6450631,18.9947961 17.4482507,18.9947961 Z",
    id: "Fill-1",
    stroke: "#FFFFFF",
    strokeWidth: 0.4,
    fill: "#FFFFFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopBarVenueGenericOver);
export default __webpack_public_path__ + "static/media/top_bar-venue-generic-over.2a62cce33ccdaf64c41e8edf6afeba94.svg";
export { ForwardRef as ReactComponent };